import { SelectData } from '@occc-app/design-system';
import {
  AudienceInAllProductInterestsTargetingAttribute,
  AudienceInAnyProductInterestsTargetingAttribute,
  AudienceNotInAllProductInterestsTargetingAttribute,
  AudienceNotInAnyProductInterestsTargetingAttribute,
  AudienceTargetingAttributesInput,
} from '@occc/graphql';

import { ProductInterestsControl, ProductInterestsMatch } from '../../types';
import { ProductInterestsValues } from '../validation';

export const productInterestsInitialValues: ProductInterestsValues = {
  match: ProductInterestsMatch.All,
  prefer: ProductInterestsControl.Prefer,
};

export const productInterestsTargetingAttributeMap: Record<
  ProductInterestsControl,
  Record<
    ProductInterestsMatch,
    keyof Pick<
      AudienceTargetingAttributesInput,
      | 'inAllProductInterestsTargetingAttribute'
      | 'inAnyProductInterestsTargetingAttribute'
      | 'notInAllProductInterestsTargetingAttribute'
      | 'notInAnyProductInterestsTargetingAttribute'
    >
  >
> = {
  [ProductInterestsControl.Prefer]: {
    [ProductInterestsMatch.All]: 'inAllProductInterestsTargetingAttribute',
    [ProductInterestsMatch.Any]: 'inAnyProductInterestsTargetingAttribute',
  },
  [ProductInterestsControl.NotPrefer]: {
    [ProductInterestsMatch.All]: 'notInAllProductInterestsTargetingAttribute',
    [ProductInterestsMatch.Any]: 'notInAnyProductInterestsTargetingAttribute',
  },
};

export const formValuesByTargetingTypename: Record<
  (
    | AudienceNotInAllProductInterestsTargetingAttribute
    | AudienceInAnyProductInterestsTargetingAttribute
    | AudienceNotInAnyProductInterestsTargetingAttribute
    | AudienceInAllProductInterestsTargetingAttribute
  )['__typename'],
  Omit<ProductInterestsValues, 'productCategories'>
> = {
  AudienceNotInAllProductInterestsTargetingAttribute: {
    match: ProductInterestsMatch.All,
    prefer: ProductInterestsControl.NotPrefer,
  },
  AudienceInAllProductInterestsTargetingAttribute: {
    match: ProductInterestsMatch.All,
    prefer: ProductInterestsControl.Prefer,
  },
  AudienceInAnyProductInterestsTargetingAttribute: {
    match: ProductInterestsMatch.Any,
    prefer: ProductInterestsControl.Prefer,
  },
  AudienceNotInAnyProductInterestsTargetingAttribute: {
    match: ProductInterestsMatch.Any,
    prefer: ProductInterestsControl.NotPrefer,
  },
};

export const titleByProductInterestsControl: Record<ProductInterestsControl, string> = {
  [ProductInterestsControl.Prefer]: 'Prefers',
  [ProductInterestsControl.NotPrefer]: 'Does Not Prefer',
};

export const titleByProductInterestsMatch: Record<ProductInterestsMatch, string> = {
  [ProductInterestsMatch.All]: 'All of',
  [ProductInterestsMatch.Any]: 'Any of',
};

export const preferItems = [
  {
    title: titleByProductInterestsControl[ProductInterestsControl.Prefer],
    value: ProductInterestsControl.Prefer,
  },
  {
    title: titleByProductInterestsControl[ProductInterestsControl.NotPrefer],
    value: ProductInterestsControl.NotPrefer,
  },
];

export const matchItems: SelectData[] = [
  {
    label: titleByProductInterestsMatch[ProductInterestsMatch.All],
    value: ProductInterestsMatch.All,
  },
  {
    label: titleByProductInterestsMatch[ProductInterestsMatch.Any],
    value: ProductInterestsMatch.Any,
  },
];
